/**
 * Módulo Footer
 * Renderiza footer com texto de copyright
 */

import BaseModule from './BaseModule.js';

export default class FooterModule extends BaseModule {
    static defaultConfig = {
        container: null,
        cssPrefix: 'mzk-footer',
        animateIn: true
    };

    constructor(config = {}) {
        super({ ...FooterModule.defaultConfig, ...config });
        this.data = null;
    }

    /**
     * Inicializa o módulo
     */
    async init() {
        if (!this.config.data) {
            throw new Error('FooterModule requer data na configuração');
        }

        this.data = this.config.data;
        this.initialized = true;
    }

    /**
     * Renderiza o footer
     */
    render(container) {
        if (!this.initialized) {
            throw new Error('Módulo não foi inicializado. Chame init() primeiro.');
        }

        this.container = container || this.config.container;
        if (!this.container) {
            throw new Error('Container é obrigatório');
        }

        const html = this.buildHTML();
        this.container.innerHTML = html;

        if (this.config.animateIn) {
            this.animateIn();
        }
    }

    /**
     * Constrói HTML do footer
     * @private
     */
    buildHTML() {
        const { cssPrefix } = this.config;
        const { texto_copy } = this.data;

        return `
      <footer class="${cssPrefix}-container">
        <div class="${cssPrefix}-disclaimer">
          <p>${this.escapeHtml(texto_copy)}</p>
        </div>
      </footer>
    `;
    }

    /**
     * Anima entrada do footer
     * @private
     */
    animateIn() {
        const element = this.container.querySelector(`.${this.config.cssPrefix}-container`);
        if (element) {
            element.classList.add('fade-in');
        }
    }

    /**
     * Escapa HTML para prevenir XSS
     * @private
     */
    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    /**
     * Atualiza conteúdo do footer
     */
    update(newData) {
        this.data = { ...this.data, ...newData };
        if (this.container) {
            this.render(this.container);
        }
    }

    /**
     * Retorna CSS do módulo
     */
    static getStyles() {
        return `
      .mzk-footer-container {
        padding-top: 2rem;
        padding-bottom: 2rem;
        margin-top: 3rem;
        box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, 0.1);
        opacity: 0;
        transition: opacity 0.5s ease-in;
      }

      .mzk-footer-container.fade-in {
        opacity: 1;
      }

      .mzk-footer-disclaimer {
        text-align: center;
        color: #000;
      }

      .mzk-footer-disclaimer p {
        margin: 0;
        font-size: 0.875rem;
        line-height: 1.5;
      }

      @media (max-width: 768px) {
        .mzk-footer-disclaimer p {
          font-size: 0.75rem;
        }
      }
    `;
    }

    /**
     * Destrói o módulo
     */
    destroy() {
        if (this.container) {
            this.container.innerHTML = '';
        }
        this.data = null;
        super.destroy();
    }
}
